import { useAuth } from 'src/hooks/use-auth';
import PushNotification from './push-notification';

const NotificationCenter = () => {
  const { user } = useAuth();

  if (!user) {
    return <></>;
  }

  const { id: uid } = user;

  return <PushNotification uid={uid} />;
};

export default NotificationCenter;
